"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuButton = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const MenuButton = _ref => {
  let {
    open,
    setOpen,
    transitionTime = 300,
    stageDelay = 100,
    color,
    backgroundColor,
    styles,
    className
  } = _ref;
  const [flip, setFlip] = (0, _react.useState)(false);

  const renderPath = (_ref2, center) => {
    let [d1, d2] = _ref2;
    return /*#__PURE__*/_react.default.createElement("path", {
      style: {
        transitionProperty: 'd',
        transitionDuration: "".concat(transitionTime, "ms"),
        transitionDelay: open && center || !(open || center) ? '' : "".concat(stageDelay, "ms")
      },
      d: open ? d2 : d1,
      fill: color,
      className: 'mainShape'
    });
  };

  const icon = /*#__PURE__*/_react.default.createElement("svg", {
    className: "xburgerButton",
    viewBox: "0 0 132.29166 132.29167",
    height: "30",
    width: "30"
  }, renderPath(flip ? ["m 3.3906325,100.69908 125.3180175,0.008 -0.001,18.59162 -125.3180167,-0.008 z", "M 28.846694,14.020461 117.45992,106.30873 104.83715,119.455 16.223931,27.166726 Z"] : ["m 4.0263095,14.267981 125.3180305,-0.01822 0.003,18.591625 -125.3180367,0.01823 z", "M 16.175122,106.15278 104.78835,13.864516 117.41112,27.010786 28.79789,119.29905 Z"], false), renderPath(["M 3.4245129,57.752314 H 128.74254 V 76.343939 H 3.4245129 Z", "M 67.752314,57.752314 H 67.752314 V 76.343939 H 67.752314 Z"], true), renderPath(flip ? ["m 4.0263095,14.267981 125.3180305,-0.01822 0.003,18.591625 -125.3180367,0.01823 z", "M 16.175122,106.15278 104.78835,13.864516 117.41112,27.010786 28.79789,119.29905 Z"] : ["m 3.3906325,100.69908 125.3180175,0.008 -0.001,18.59162 -125.3180167,-0.008 z", "M 28.846694,14.020461 117.45992,106.30873 104.83715,119.455 16.223931,27.166726 Z"], false));

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "thingy"
  }, flip), /*#__PURE__*/_react.default.createElement("button", {
    className: "xburgerMenuButton styleOverride ".concat(className),
    onClick: () => {
      if (open) setFlip(f => !f);
      setOpen(!open);
    },
    style: _objectSpread(_objectSpread({}, styles), {}, {
      backgroundColor
    })
  }, icon));
};

exports.MenuButton = MenuButton;